import createHistory from 'history/createBrowserHistory'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { persistReducer, persistStore } from 'redux-persist'
import createEncryptor from 'redux-persist-transform-encrypt'
import storage from 'redux-persist/lib/storage'
import * as persistActionCreators from './actions/PersistAction'
import middlewares from './reducers/middlewares'
import rootReducer from './reducers/RootReducer'
export const history = createHistory()

const encryptor = createEncryptor({
  secretKey: 'Quam Fusce Commodo Pellentesque',
  onError: function(error) {
    throw error
  },
})

const persistConfig = {
  key: 'intake',
  whitelist: ['AuthReducer'],
  transforms: [encryptor],
  storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middlewares)))

export const persistor = persistStore(store, () => store.dispatch(persistActionCreators.update({ isHydrated: true })))

export default store



// WEBPACK FOOTER //
// ./src/Store.js